// src/pages/AdminDashboard.jsx
import { useEffect, useState } from "react";
import { getAllUsers } from "../api/apiService";
import UserEditPopup from "../components/popups/UserEditPopup";
import ConfirmDeletePopup from "../components/popups/ConfirmDeletePopup";

const AdminDashboard = () => {
  const [users, setUsers] = useState([]);
  const [editUser, setEditUser] = useState(null);
  const [deleteUser, setDeleteUser] = useState(null);

  useEffect(() => {
    (async () => {
      const data = await getAllUsers();
      setUsers(data);
      console.log("Fetched users:", data); // Debug
    })();
  }, []);

  const handleSave = (updatedUser) => {
    const updatedList = users.map((u) =>
      u.id === updatedUser.id ? updatedUser : u
    );
    setUsers(updatedList);
    setEditUser(null);
  };

  const handleDelete = (userId) => {
    const filtered = users.filter((u) => u.id !== userId);
    setUsers(filtered);
    setDeleteUser(null);
  };

  return (
    <div className="">
      <h1 className="text-2xl font-bold mb-6">
        Admin – All User Registrations
      </h1>

      <div className="overflow-x-auto">
        <table className="min-w-full table-auto border border-gray-300">
          <thead className="bg-primary text-white">
            <tr>
              <th className="p-2 border">#</th>
              <th className="p-2 border">Full Name</th>
              <th className="p-2 border">Email</th>
              <th className="p-2 border">Phone</th>
              <th className="p-2 border">Citizenship</th>
              <th className="p-2 border">Passport No</th>
              <th className="p-2 border">DOB</th>
              <th className="p-2 border">Gender</th>
              <th className="p-2 border">Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.length === 0 ? (
              <tr>
                <td colSpan="8" className="text-center p-4 text-gray-500">
                  No users found
                </td>
              </tr>
            ) : (
              users.map((user, index) => {
                const personal = user.personalInfoDTO;
                return (
                  <tr
                    key={personal.personalId}
                    className="odd:bg-white even:bg-gray-100"
                  >
                    <td className="p-2 border text-center">{index + 1}</td>
                    <td className="p-2 border">{`${personal.firstName} ${personal.lastName}`}</td>
                    <td className="p-2 border">{personal.email}</td>
                    <td className="p-2 border">{personal.phone}</td>
                    <td className="p-2 border">{personal.citizenship}</td>
                    <td className="p-2 border">{personal.passportNo}</td>
                    <td className="p-2 border">{personal.dob}</td>
                    <td className="p-2 border">{personal.gender}</td>
                    <td className="p-2 border text-center">
                      <button
                        onClick={() => setEditUser(user)}
                        className="text-blue-500 hover:underline mr-2"
                      >
                        Edit
                      </button>
                      <button
                        onClick={() => setDeleteUser(user)}
                        className="text-red-500 hover:underline"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
      <UserEditPopup
        user={editUser}
        onClose={() => setEditUser(null)}
        onSave={handleSave}
      />
      <ConfirmDeletePopup
        user={deleteUser}
        onCancel={() => setDeleteUser(null)}
        onConfirm={handleDelete}
      />
    </div>
  );
};

export default AdminDashboard;
